import { FormGroup } from '@angular/forms';
import { ITimesheetFormControls } from '../interfaces/timesheets';
import { TimeSheet } from './timesheet.model';

export interface IAdminTimesheetJson {
    userProfileId: string;
    name: string;
    billingHours: number;
    ptoHours: number;
    week: number;
    year: number;
    isSelected: boolean;
    is1099: boolean;
    submitted: boolean;
    timesheetGroup: FormGroup<ITimesheetFormControls>[];
}

interface IAdminTimesheetConstructor {
    userProfileId: string;
    name: string;
    billingHours: number;
    ptoHours: number;
    week: number;
    year: number;
    isSelected: boolean;
    is1099: boolean;
    submitted: boolean;
    timesheetGroup: FormGroup<ITimesheetFormControls>[];
}

export interface AdminTimesheet extends IAdminTimesheetConstructor {
    userProfileId: string;
    name: string;
    billingHours: number;
    week: number;
    year: number;
    isSelected: boolean;
    is1099: boolean;
    submitted: boolean;
    timesheetGroup: FormGroup<ITimesheetFormControls>[];
}

export class AdminTimesheet {
    constructor(input: IAdminTimesheetConstructor) {
        Object.assign(this, input);
    }

    static fromJson(json: IAdminTimesheetJson): AdminTimesheet | null {
        if (json == null) {
            return null;
        }

        return new AdminTimesheet({
            ...json,
        });
    }
}

export interface UserTimesheets {
    countRequested: number;
    offsetRequested: number;
    totalCount: number;
    items: TimeSheet[];
}

interface IEmail {
    subject: string | null;
    body: string | null;
}

export class Email implements IEmail {
    constructor(
        public subject: string | null = '',
        public body: string | null = '',
    ) {}
}
